import { engineComponent } from "neo-common";
import { Controller } from "../Controller";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { FreespinsView } from "./FreespinsView";
import { FreespinsModel } from "./FreespinsModel";

@engineComponent(ComponentTypes.Controller)
export class FreespinsController extends Controller {
    public static readonly StartReceived: string = "eventStartReceived";
    public static readonly SpinReceived: string = "eventSpinReceived";
    public static readonly EndReceived: string = "eventEndReceived";
    public static readonly MachineStopped: string = "eventMachineStopped";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly IntroFinished: string = "eventIntroFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";

    protected _view: FreespinsView;
    protected _model: FreespinsModel;

    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof FreespinsView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new FreespinsModel(this);
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initIntro(): void {
        this._view.initIntro();
    }

    start(): void {
        this._model.start();
    }

    spin(): void {
        this._model.spin();
        this._view.spin();
    }

    respin(): void {
        this._model.respin();
        this._view.respin();
    }

    end(): void {
        this._model.end();
    }

    stop(): void {
        this._view.stop();
    }

    startReceived(): void {
        this._view.startReceived();
        this.emit(FreespinsController.StartReceived);
    }

    spinReceived(): void {
        this._view.spinReceived();
        this.emit(FreespinsController.SpinReceived);
    }

    endReceived(): void {
        this._view.endReceived();
        this.emit(FreespinsController.EndReceived);
    }

    machineStopped(): void {
        this.emit(FreespinsController.MachineStopped);
    }

    winCalculationFinished(): void {
        this.emit(FreespinsController.WinCalculationFinished);
    }

    allWinsFinished(): void {
        this.emit(FreespinsController.AllWinsFinished);
    }

    intro(long: boolean = false): void {
        this._view.intro(long);
    }

    introFinished(): void {
        this.emit(FreespinsController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(FreespinsController.OutroFinished);
    }

    enable(): void {
        this._view.enable();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsController.ts
 **/